// extracted by mini-css-extract-plugin
module.exports = {"phantomFull":"CaptionLabel-module--phantom-full--dfwBh","captionLabel":"CaptionLabel-module--captionLabel--R-zPC"};